var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 7,
    stroke: "#BABABA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9396 16.9115C22.7744 18.1712 22.2694 19.3621 21.4788 20.3566C20.6882 21.3511 19.6417 22.1117 18.4517 22.5567C17.2617 23.0017 15.973 23.1143 14.7239 22.8826C13.4747 22.6508 12.3122 22.0834 11.361 21.2412C10.4098 20.399 9.70583 19.3137 9.32455 18.1018C8.94327 16.8899 8.89908 15.597 9.19672 14.3619C9.49436 13.1268 10.1226 11.996 11.0141 11.0908C11.9055 10.1856 13.0266 9.5401 14.257 9.22361C17.6679 8.3488 21.1987 10.1045 22.5022 13.3764",
    stroke: "#2173FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9981 9.00391V13.378H18.624",
    stroke: "#2173FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpdate);
export default __webpack_public_path__ + "static/media/icon_update.2c563034b035e0bc7e1ac28233e1e9b8.svg";
export { ForwardRef as ReactComponent };